// The 404 screen (design-system spec §3.9 states).
//
// TanStack Router's DEFAULT not-found component is a bare unstyled
// `<p>Not Found</p>`. It rendered inside the full signed-in shell with no way
// back, so a mistyped or stale link — `/terminology` instead of
// `/settings/terminology` — dropped a factory admin onto two words of browser
// default type in the middle of the product (UX-1 surface review F15).
//
// The §3.9 grammar instead: one claim, one obvious next action.

import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EmptyState } from "../components/states";

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="page" data-testid="not-found">
      <EmptyState
        title={t("notFound.title")}
        body={t("notFound.body")}
        ctaLabel={t("notFound.cta")}
        onCta={() => {
          void navigate({ to: "/home" });
        }}
      />
    </div>
  );
}
